import { Component } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { MicrosoftSessionService } from '../../services/microsoft-session.service';

/**
 * The only automatic-navigation-free way back into Microsoft.
 *
 * Renders nothing at all until a feature that genuinely needs Graph (Outlook
 * calendar, appointments, SharePoint) failed to get a token silently. Then, and
 * only then, it offers the user an explicit reconnect: the full-page redirect
 * happens on their click, so landing on a Microsoft sign-in screen is the
 * expected outcome rather than a surprise that costs them the page they were on.
 *
 * Cosmetic Graph use (the profile photo) never raises this - see
 * MicrosoftSessionService's `essential` flag.
 */
@Component({
  selector: 'app-microsoft-reconnect',
  standalone: true,
  imports: [MaterialModule],
  template: `
    @if (microsoftSession.reconnectRequired()) {
      <button
        mat-stroked-button
        color="warn"
        type="button"
        class="ms-reconnect-btn d-flex align-items-center gap-4"
        matTooltip="Microsoft could not be reached silently. Sign in again to restore Outlook and SharePoint features."
        (click)="reconnect()">
        <i class="iconify icon-16 d-flex" data-icon="solar:refresh-line-duotone"></i>
        <span class="f-s-12">Reconnect Microsoft</span>
      </button>
    }
  `,
})
export class MicrosoftReconnectComponent {
  constructor(public microsoftSession: MicrosoftSessionService) {}

  reconnect(): void {
    this.microsoftSession.reconnectInteractively();
  }
}
